export function humanMemSize(
  size: number,
  round = true,
  placeholder = "0",
  withUnits = true,
) {
  if (!size) return placeholder;
  // The Math.min here artificially restricts the output
  // to using GB as the largest possible unit size.
  let i = Math.min(Math.floor(Math.log(size) / Math.log(1024)), 3);
  return `${(size / Math.pow(1024, i)).toFixed(round ? 0 : 2)}${
    withUnits ? " " + ["B", "kB", "MB", "GB"][i] : ""
  }`;
}
